import { CircularProgress, Typography } from '@material-ui/core';
import { unstable_Box as Box } from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import { HourglassEmpty as HourglassIcon } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: 60,
  },
  circleWrapper: {
    position: 'relative',
    display: 'inline-block',
    width: 60,
    height: 60,
  },
  bottomCircle: {
    color: theme.palette.grey[300],
    position: 'absolute',
    top: 0,
    left: 0,
  },
  topCircle: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  centerText: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
});

const CountdownCircle = ({ classes, expiresAt, duration, onExpire, timeOffset = 0 }) => {
  const [timeLeft, setTimeLeft] = useState(null);
  const [totalDuration, setTotalDuration] = useState(null);

  useEffect(() => {
    const getSecondsLeft = () => {
      const adjustedNow = Math.floor(Date.now() / 1000) + timeOffset;
      return Math.max(0, Math.floor(expiresAt - adjustedNow));
    };

    const updateTimeLeft = () => {
      const secondsLeft = getSecondsLeft();
      setTimeLeft(secondsLeft);
      if (secondsLeft <= 0 && typeof onExpire === 'function') {
        onExpire();
      }
    };

    setTotalDuration(Math.max(duration, getSecondsLeft()));
    updateTimeLeft();

    const timer = setInterval(updateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, [expiresAt, duration, timeOffset, onExpire]);

  const progress = totalDuration > 0 ? (timeLeft / totalDuration) * 100 : 0;

  const formatTime = (seconds) => {
    const min = String(Math.floor(seconds / 60)).padStart(2, '0');
    const sec = String(seconds % 60).padStart(2, '0');
    return `${min}:${sec}`;
  };

  const getProgressColor = () => {
    if (timeLeft <= totalDuration / 4) return '#EF5350';
    if (timeLeft <= totalDuration / 2) return '#FFA726';

    return '#66BB6A';
  };

  if (!totalDuration) return null;

  return (
    <div className={classes.container}>
      {timeLeft > 0 ? (
        <div className={classes.circleWrapper}>
          <CircularProgress variant='static' value={100} size={60} thickness={6} className={classes.bottomCircle} />
          <CircularProgress
            size={60}
            thickness={6}
            variant='static'
            value={progress}
            className={classes.topCircle}
            style={{ color: getProgressColor() }}
          />
          <Typography variant='body2' className={classes.centerText}>
            {formatTime(timeLeft)}
          </Typography>
        </div>
      ) : (
        <Box display='flex' alignItems='center'>
          <HourglassIcon color='error' />
          <Box marginLeft={1}>
            <Typography variant='caption' color='error'>
              {"Vous n'avez plus la priorité !"}
            </Typography>
          </Box>
        </Box>
      )}
    </div>
  );
};

export default withStyles(styles)(CountdownCircle);
